import { Box } from "@mui/material";
import { useAtom, useSetAtom } from "jotai";
import { formDataAtom, otherErrorsAtom, updateFieldAtom } from "../store/onboardingModalStore";
import { referralOptions } from "../constants/chipData";
import { OnboardingSelectionChip } from "./shared/OnboardingSelectionChip";
import { OnboardingStepLayout } from "./shared/OnboardingStepLayout";
import { OnboardingOtherInput } from "./shared/OnboardingOtherInput";

export const OnboardingReferral = (): JSX.Element => {
  const [formData] = useAtom(formDataAtom);
  const updateField = useSetAtom(updateFieldAtom);
  const [otherErrors, setOtherErrors] = useAtom(otherErrorsAtom);

  const isOtherSelected = formData.referralSource === "other";

  const handleSelect = (value: string): void => {
    updateField({ referralSource: value });
    if (value !== "other") {
      const { referralSource: _, ...rest } = formData.otherTexts;
      updateField({ otherTexts: rest });
    }
  };

  return (
    <OnboardingStepLayout
      title="How did you hear about DeskDay?"
      subtitle={`Knowing how you found us helps us reach more ${formData.orgType === "msp" ? "MSPs" : "IT teams"} like you.`}
    >
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
        {referralOptions.map((option) => (
          <OnboardingSelectionChip
            key={option.value}
            label={option.label}
            isSelected={formData.referralSource === option.value}
            onClick={() => handleSelect(option.value)}
          />
        ))}
      </Box>
      {isOtherSelected && (
        <Box sx={{ marginTop: "8px" }}>
          <OnboardingOtherInput
            value={formData.otherTexts.referralSource ?? ""}
            onChange={(val) =>
              updateField({
                otherTexts: { ...formData.otherTexts, referralSource: val },
              })
            }
            error={!!otherErrors.referralSource}
            onErrorClear={() => {
              const { referralSource: _, ...rest } = otherErrors;
              setOtherErrors(rest);
            }}
          />
        </Box>
      )}
    </OnboardingStepLayout>
  );
};
